<template>
  <div class="review">
    Metrics Report
  </div>
</template>
<script>

export default {
  name: 'review'
}
</script>
